import { Box } from '@frameio/vapor';

type InfoListContainerProps = {
  children: React.ReactNode;
};

const InfoListContainer = ({ children }: InfoListContainerProps) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={1}
      overflow="hidden"
      style={{ borderRadius: '12px' }}
      width="100%"
    >
      {children}
    </Box>
  );
};

type InfoListRowProps = {
  children: React.ReactNode;
};

const InfoListRow = ({ children }: InfoListRowProps) => {
  return (
    <Box
      alignItems="flex-start"
      backgroundColor="primary"
      display="flex"
      gap={12}
      justifyContent="space-between"
      minHeight={32}
      paddingX={12}
      paddingY={4}
      width="100%"
    >
      {children}
    </Box>
  );
};

export { InfoListContainer, InfoListRow };
